import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DebugService } from '@core/services/debug/debug.service';
import { PalantirTooltipModule } from '@flux/design-system';

@Component({
  selector: 'app-debug-indicator',
  imports: [PalantirTooltipModule],
  templateUrl: './debug-indicator.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebugIndicatorComponent {
  constructor(public readonly debugService: DebugService) {}
}
